import { render, staticRenderFns } from "./CclRecord.vue?vue&type=template&id=2b7ff731&scoped=true&"
import script from "./CclRecord.vue?vue&type=script&lang=js&"
export * from "./CclRecord.vue?vue&type=script&lang=js&"
import style0 from "./CclRecord.vue?vue&type=style&index=0&id=2b7ff731&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7ff731",
  null
  
)

export default component.exports